import React from 'react';
import { connect, batch } from 'react-redux';

import {
    toggleIsFetchingNewsFlag,
    fetchAllNews,
    updateRoleTemplateNews
} from '../../actions';
import RoleTemplatesTable from '../common/RoleTemplatesTable';
import SearchFilter from '../common/SearchFilter';
import pushMessage from '../common/PushMessage';
import CONFIG from '../../config';

class RoleTemplatesNews extends React.Component {

    getFilterDropDown = (filterProps, dataIndex) => {
        const { setSelectedKeys, selectedKeys, confirm, clearFilters } = filterProps;
        return (
            <SearchFilter
                dataIndex={dataIndex}
                searchString={selectedKeys[0]}
                setSearchString={setSelectedKeys}
                confirm={confirm}
                handleClear={this.handleClear}
                handleSearch={this.handleFilter}
                clearFilters={clearFilters}
            />
        )
    }

    columnFilters = {
        filterDropdown: (filterProps) => this.getFilterDropDown(filterProps, "title"),
        sorter: true
    }

    filterSort = {}

    handleFilter = (title, confirm) => {
        title = title?.trim();
        if (!title && !this.filterSort.filter) {
            pushMessage(CONFIG.messageType.warning, "Please enter a search string")
            return;
        }
        else confirm()
    }

    handleClear = (clearFilters) => {
        clearFilters();
    }

    handleChange = (pagination, filters, sorter) => {

        this.filterSort = {
            filter: filters.title?.[0] ? { title: filters.title[0] } : undefined,
            sort: sorter.columnKey
                ? {
                    [sorter.columnKey]: CONFIG.sortMap[sorter.order]
                }
                : undefined
        }

        batch(() => {
            this.props.toggleIsFetchingNewsFlag(true);
            this.props.fetchAllNews({
                pageNumber: pagination.current,
                pageSize: (CONFIG.shortPageSize + 1),
                access: this.access,
                filterSort: this.filterSort
            });
        });
    }

    componentDidMount() {
        const { userRoleTemplate } = this.props;
        this.access = userRoleTemplate.templateType === CONFIG.roleTypes.admin ? CONFIG.roleTemplateAccess.fullAccess : undefined;
        this.props.toggleIsFetchingNewsFlag(true);
        this.props.fetchAllNews({ access: this.access });
    }

    render() {
        const { news, count, assignedNews, isFetching, allNewsUserAccess, allNewsAdminAccess, updateRoleTemplateNews, templateType } = this.props;
        return (
            <RoleTemplatesTable
                dataKey="news"
                hideColumns={templateType === CONFIG.roleTypes.admin ? [] : ['admin']}
                marginTop={true}
                bordered={true}
                data={news}
                selectAllDisabled={this.filterSort.filter !== undefined}
                columnFilters={this.columnFilters}
                onChange={this.handleChange}
                pagination={{
                    pageSize: CONFIG.shortPageSize + 1,
                    total: count
                }}
                isFetching={isFetching}
                assignedData={assignedNews}
                allAdminAccess={allNewsAdminAccess}
                allUserAccess={allNewsUserAccess}
                updateRoleTemplateData={(updateRoleTemplateNews)}
            />
        );
    }
}

const mapStateToProps = ({ news, roleTemplate, user }) => {
    return {
        news: news.data,
        count: news.count,
        isFetching: news.isFetching,
        assignedNews: roleTemplate.news,
        allNewsUserAccess: roleTemplate.allNewsUserAccess,
        allNewsAdminAccess: roleTemplate.allNewsAdminAccess,
        templateType: roleTemplate.templateType,
        userRoleTemplate: user.profile ? user.profile.roleTemplate : undefined
    }
}

export default connect(
    mapStateToProps,
    {
        toggleIsFetchingNewsFlag,
        fetchAllNews,
        updateRoleTemplateNews
    }
)(RoleTemplatesNews);